import { Component, computed, ElementRef, inject, signal, viewChild } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { IconComponent } from 'app/shared/components/icon/icon.component';
import { initialsOf } from './initials-of';

@Component({
  selector: 'ez-account-menu',
  imports: [IconComponent],
  templateUrl: './account-menu.component.html',
  styleUrl: './account-menu.component.scss',
  host: {
    '(document:click)': 'closeOnOutsideClick($event)',
    '(document:keydown.escape)': 'closeOnEscape()',
    '(focusout)': 'closeOnFocusLeave($event)',
  },
})
export class AccountMenuComponent {
  protected readonly auth = inject(AuthService);
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly chip = viewChild<ElementRef<HTMLButtonElement>>('chip');

  protected readonly panelId = 'account-menu-panel';
  protected readonly isOpen = signal(false);
  protected readonly initials = computed(() => {
    const user = this.auth.user();
    return user ? initialsOf(user) : null;
  });

  protected toggle(): void {
    this.isOpen.update((open) => !open);
  }

  protected closeOnEscape(): void {
    if (this.isOpen()) {
      this.isOpen.set(false);
      this.chip()?.nativeElement.focus();
    }
  }

  protected closeOnFocusLeave(event: FocusEvent): void {
    const nextFocus = event.relatedTarget as Node | null;
    if (nextFocus && !this.host.nativeElement.contains(nextFocus)) {
      this.isOpen.set(false);
    }
  }

  protected closeOnOutsideClick(event: Event): void {
    if (!this.host.nativeElement.contains(event.target as Node)) {
      this.isOpen.set(false);
    }
  }
}
